import React from 'react';
import 'font-awesome/css/font-awesome.min.css';
import { Helmet } from 'react-helmet';



const Amenities = () => {
  const facilities = [
    {
      title: 'Washing Machine',
      icon: 'fa fa-tshirt',  // Font Awesome Washing Machine Icon
      items: ['Washing Machine available for all rooms'],
    },
    {
      title: 'Wi-Fi',
      icon: 'fa fa-wifi',  // Font Awesome Wi-Fi Icon
      items: ['Free high-speed Wi-Fi in all areas'],
    },
    {
      title: 'TV in Each Room',
      icon: 'fa fa-tv',  // Font Awesome TV Icon
      items: ['Each room is equipped with a TV'],
    },
    {
      title: '24/7 Water Supply',
      icon: 'fa fa-tint',  // Font Awesome Water Icon
      items: ['Round-the-clock water supply available'],
    },
    {
      title: 'Geyser',
      icon: 'fa fa-bath',  // Font Awesome Bath Icon (Represents Hot Water Geyser)
      items: ['Geyser available in every bathroom'],
    },
    {
      title: '2-Wheeler Parking Available',
      icon: 'fa fa-motorcycle',  // Font Awesome Motorcycle Icon (Represents 2-Wheeler Parking)
      items: ['Dedicated parking space for 2-wheelers'],
    },
    {
      title: 'Fridge',
      icon: 'fa fa-snowflake',  // Font Awesome Snowflake Icon (For Cooling/Fridge)
      items: ['Fridge provided in each room'],
    },
    {
      title: 'Gas Connection',
      icon: 'fa fa-fire',  // Font Awesome Fire Icon (Represents Gas)
      items: ['Gas connection available in each room for cooking'],
    },
    {
      title: '24 Hours Hot Water',
      icon: 'fa fa-hot-tub',  // Font Awesome Hot Tub Icon (Represents Hot Water)
      items: ['Hot water available 24 hours a day'],
    },
    {
      title: 'Free Housekeeping',
      icon: 'fa fa-broom',  // Font Awesome Broom Icon (Represents Housekeeping)
      items: ['Free daily housekeeping services'],
    },
    {
      title: 'Free Electric Bill',
      icon: 'fa fa-bolt',  // Font Awesome Bolt Icon (Represents Electricity)
      items: ['Electricity bill included in the rent'],
    },
    {
      title: 'Purified Drinking Water',
      icon: 'fa fa-droplet',  // Font Awesome Droplet Icon (Represents Purified Water)
      items: ['Purified drinking water provided'],
    },
    {
      title: 'CCTV Surveillance',
      icon: 'fa fa-video-camera',  // Font Awesome Video Camera Icon (Represents CCTV)
      items: ['24/7 CCTV surveillance for safety and security'],
    },
  ];
  
      
  return (
    <>

<Helmet>
 
 <script type="application/ld+json">
   {JSON.stringify({
     "@context": "https://schema.org",
     "@type": "Organization",
     "name": "Om Sai PG",
     "description": "Om Sai PG offers affordable PG accommodations in Kharadi, Pune, with food, for students, working professionals, and residents, near Eon IT Park.",
     "url": "https://www.omsaipg.in",
     "logo": "https://www.omsaipg.in/images/logo.jpg",
     "image":"https://www.omsaipg.in/images/ogimage.jpg",
     "contactPoint": [
       {
         "@type": "ContactPoint",
         "telephone": "+91 9763888448",
         "contactType": "Customer Service",
         "areaServed": "IN",
         "availableLanguage": "English",
       },
       {
         "@type": "ContactPoint",
         "telephone": "+91 9922248255",
         "contactType": "Customer Service",
         "areaServed": "IN",
         "availableLanguage": "English",
       },
     ],
     "aggregateRating": {
       "@type": "AggregateRating",
       "bestRating": "5",
       "worstRating": "1",
       "ratingValue": "4.7",
       "ratingCount": "250",
     },
     "email": "omsaipg@gmail.com",
     "address": {
       "@type": "PostalAddress",
       "streetAddress": "Tulja Bhavani Nagar, Lane No 7, Near Durga Mata Mandir",
       "addressLocality": "Kharadi",
       "addressRegion": "Maharashtra",
       "postalCode": "411014",
       "addressCountry": "IN",
     },
     "sameAs": [
       "https://www.facebook.com/omsaipg",
       "https://www.instagram.com/omsaipg",
       "https://www.linkedin.com/company/omsaipg"
     ],
     "priceRange": "INR 8,500-6000",
     "paymentAccepted": "Cash, UPI, Credit Card",
     "telephone": "+91 9763888448",
     "email": "omsaipgpune@gmail.com",
     "keywords": [
       "PG in Pune",
       "PG in Kharadi",
       "PG with food in Pune",
       "PG for students in Kharadi",
       "PG for females in Pune",
       "PG for males in Pune",
       "Om Sai PG Kharadi",
       "Girls Hostels in Kharadi",
       "Boys Hostel in Kharadi",
       "Monthly Basis PG in Kharadi",
       "PG in Wagholi",
       "PG in Kharadi with food",
       "Hostels in Pune",
       "PG for Students in Kharadi Pune",
       "Paying Guest Hostel in Chandan Nagar"
     ],
     "openingHours": "Mo-Su 09:00-22:00"
   })}
 </script>

 {/* Title */}
 <title>
   Contact : +91 9763888448 / +91 9922248255 | Om Sai PG |  Amenities | Hostels in Pune  |PG for Students in Kharadi Pune | Paying Guest Hostel in Chandan Nagar
 </title>

 {/* Meta Tags */}
 <meta
   name="description"
   content="Om Sai PG offers the best PG accommodations in Kharadi, Pune. We provide PG for students, males, females, with food and other essential amenities."
 />
 <meta
   name="keywords"
   content="Hostels in Pune,PG for Students in Kharadi Pune,Paying Guest Hostel in Chandan Nagar"
 />
 <meta name="robots" content="index, follow" />

 {/* Open Graph Tags */}
 <meta
   property="og:title"
   content="Om Sai PG - Best PG Accommodation in Kharadi Pune | PG with Food | Paying Guest in Kharadi"
 />
 <meta
   property="og:description"
   content="Looking for the best PG in Kharadi Pune? Om Sai PG offers comfortable and affordable accommodation for students, professionals, and residents with food included."
 />
 <meta property="og:image" content="https://www.omsaipg.in/ogimage.jpg" />
 <meta property="og:url" content="https://www.omsaipg.in" />
 <meta property="og:type" content="website" />
</Helmet>

      <section className="section-breadcrumb padding-b-50">
        <div className="rx-breadcrumb-image bg-img2">
          <div className="rx-breadcrumb-overlay"></div>
          <div className="inner-breadcrumb-contact">
            <div className="main-breadcrumb-contact">
              <div className="container">
                <div className="row">
                  <div className="col-12">
                    <div className="rx-banner-contact">
                      <h2>Amenities</h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="rx-banner-breadcrumb">
              <div className="container">
                <div className="row">
                  <div className="col-12">
                    <div className="breadcrumb-contact">
                      <div className="main-heading">
                        <h4>Amenities</h4>
                      </div>
                      <div className="last-contact">
                        <ul>
                          <li>
                            <a href="index.html">Home</a>
                          </li>
                          <li>Amenities</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section-services padding-tb-50 ameniti-section">
        <div className="container">
          <div className="row mb-minus-24">
            <div className="col-12">
              <div className="rx-banner text-center">
                <h3 className='text-yellow'>Facilities</h3>
                <h4>
                  "Modern Comforts for a Seamless Living Experience" <br />
                  <span>Experience Premium Facilities at Om Sai PG</span>
                </h4>
              </div>
            </div>
            {facilities.map((facility, index) => (
              <div
                className="col-xl-3 col-lg-4 col-sm-6 col-12 mb-24 rx-575-50"
                key={index}
                data-aos-delay={index * 200}
              >
                <div className="rx-services"> 
                  <div className="services-ico">
                  <i className={facility.icon}></i> 
                  </div>
                  <div className="services-contact">
                    <h5>{facility.title}</h5>
                    <ul>
                      {facility.items.map((item, itemIndex) => (
                        <li key={itemIndex}>- {item}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Amenities;
